import { h } from '@/lib/dom';
import { navigate } from '@/router';

/**
 * Full-width error state with a "Повторить" button that re-navigates to `route`
 * (replace), forcing the page handler to re-run and refetch. Shared by the
 * window-based data pages (sleep / training / nutrition).
 */
export function errorRetry(err: unknown, message: string, route: string): HTMLElement {
  console.error(err);
  return h('div', { class: 'empty-state', role: 'alert' }, [
    h('p', null, message),
    h('button', {
      class: 'btn btn-secondary mt-2',
      type: 'button',
      on: { click: () => navigate(route, { replace: true }) },
    }, 'Повторить'),
  ]);
}
